<template functional>
  <div class="youtube-image__wrapper">
    <SocialImage
      title="YouTube"
      v-bind="data.attrs"
      :class="[data.class, data.staticClass]"
      channel="youtube"
      v-on="listeners"
    />
  </div>
</template>

<script>
import SocialImage from './SocialImage';

export default {
  name: 'YoutubeImage',
  components: {
    SocialImage,
  },
};
</script>
